import React from "react";
import './cursor.scss';

export function Cursor() {
    return (
        <>
            <svg
                data-v-a0f090ca=""
                id="cursor"
                width="90"
                height="90"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle
                    data-v-a0f090ca=""
                    id="cursor-dot"
                    fill="#FFFFFF"
                    stroke="#FFFFFF"
                    strokeWidth="8"
                    cx="45"
                    cy="45"
                    r="19"
                    data-svg-origin="45 45"
                    transform="matrix(1,0,0,1,0,0)"
                ></circle>
                <circle
                    data-v-a0f090ca=""
                    id="cursor-pin"
                    fill="#FFFFFF"
                    cx="45"
                    cy="45"
                    r="2"
                    data-svg-origin="43 43"
                ></circle>
                <path
                    data-v-a0f090ca=""
                    id="cursor-shape"
                    d="M43.243 35l9.9 9.9-.051.05.05.05-9.9 9.9L39 50.656l5.707-5.708L39 39.243 43.243 35z"
                    fill="#FFFFFF"
                    data-svg-origin="46.07149887084961 44.95000076293945"
                    transform="matrix(0,0,0,0,46.07149887084961,44.95000076293945)"
                ></path>
            </svg>
        </>
    );
}
